module.exports = __webpack_public_path__ + "img/23_11.e1db4098.png";